/**
 * karmabooking-api
 *
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2020 Karmabunny
 */

import { api } from "./base";
import { PaymentJson } from "./payment";


export type BookingStatus =
    | 'pre'
    | 'editing'
    | 'processing'
    | 'error'
    | 'complete'
    | 'expired'
;

export interface BookingJson {
    bookingId: string;

    // Core stuff, always present
    categoryId: number;
    dateArrival: string;
    dateDeparture: string;
    adults: number;
    children: number;
    infants: number;

    // More stuff
    isEditable: boolean;
    status: BookingStatus;
    dateCreated: string;
    dateUpdated: string;

    // Some RMS things
    reservationId?: number;
    rateTypeId?: number;
    bookingSourceId?: number;
    discountId?: number;
    requirementIds: number[];

    // Personal deets
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    phoneNumber?: string;

    // Address
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postcode?: string;
    countryCode?: string;

    // etc
    checkInTime?: string;
    notes?: string;
    promoCode?: string;
    terms?: boolean;

    // If processing / not editable.
    currency: string;
    payment?: PaymentJson;
    totalAmount?: number;
    payableAmount?: number;
    discountAmount?: number;
}

export interface CreateBookingJson {
    categoryId: number;
    dateArrival: string;
    dateDeparture: string;
    adults: number;
    children?: number;
    infants?: number;
}


export async function createBooking(booking: CreateBookingJson) {
    const res = await api({
        method: "POST",
        endpoint: "/book/api/booking.json",
        body: booking,
    });

    return res as BookingJson;
}


export async function getBooking(bookingId: string) {
    const res = await api({
        method: "GET",
        endpoint: "/book/api/booking.json",
        query: { bookingId },
    });
    return res as BookingJson;
}


export async function editBooking(bookingId: string, booking: Partial<BookingJson>) {
    const res = await api({
        method: "PUT",
        endpoint: "/book/api/booking.json",
        query: { bookingId },
        body: booking,
    });

    return res as Partial<BookingJson>;
}
